import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ReportCsvDownloadResponse, reportDownloaderService } from '../services/reportDownloader';
import { saveAs } from 'file-saver';
import Toast from '@/shared/services/toast';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportDownloader',
  setup(__props) {

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const selectedDateOption = computed(() => store.getters.selectedDateOption);
const selectedFlowId = computed(() => store.getters.selectedFlowId);
const isReportLoading = computed(() => store.getters.isReportLoading);
const setReportLoading = (loading: boolean) => store.commit(SET_REPORT_LOADING, loading);

const isDownloadInProgress = ref(false);

const activeRoute = useRoute();

async function downloadReport() {
  try {
    isDownloadInProgress.value = true;
    setReportLoading(true);
    const report = await getReport();
    if (report) {
      saveAs(report.data, report.fileName);
    }
  } catch (error: any) {
    Toast.showError(`Failed to download report: ${error.message}`);
  } finally {
    setReportLoading(false);
    isDownloadInProgress.value = false;
  }
}

async function getReport(): Promise<ReportCsvDownloadResponse | null> {
  const currentRoute = typeof activeRoute.name === 'string' ? activeRoute.name : String(activeRoute.name ?? '');

  if (currentRoute === 'reports-overview') {
    return await reportDownloaderService.getMessagingReportCsv(currentWorkspace.value.id, selectedDateOption.value);
  }
  if (currentRoute === 'reports-flows') {
    return reportDownloaderService.getFlowsReportCsv(
      currentWorkspace.value.id,
      selectedFlowId.value,
      selectedDateOption.value,
    );
  }
  if (currentRoute === 'reports-intents') {
    return reportDownloaderService.getNLPReportCsv(currentWorkspace.value.id, selectedDateOption.value);
  }
  if (currentRoute === 'reports-usage') {
    return reportDownloaderService.getUsageReportCsv(currentWorkspace.value.id, selectedDateOption.value);
  }
  return null;
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createBlock(_component_n_button, {
    class: "report-download-button",
    variant: "secondary",
    loading: isDownloadInProgress.value,
    disabled: isDownloadInProgress.value || isReportLoading.value,
    onClick: downloadReport
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode("Download ", -1)
    ]))]),
    _: 1
  }, 8, ["loading", "disabled"]))
}
}

})